import { Inter } from 'next/font/google';
const inter = Inter({ subsets: ['latin'] });
import './globals.css';

export const metadata = {
    title: 'Sail on Bamboo',
    description: 'Generated by Next.js',
};

export default function RootLayout({ children }) {
    return (
        <html lang="fr">
        <head>
            <title>Sail on Bamboo</title>
            <meta name="description" content="Welcome to Sail on Bamboo website" />
            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
            <link rel="stylesheet" href="/custom-bootstrap.css" />
            <link rel="icon" href="/logo/logo-transparent-white contours.png" />
        </head>
        <body className={`bg-white dark:bg-dark p-0 ${inter.className}`}>
            {children}
        </body>
        </html>
    );
}